class WCProductForm extends HTMLElement {
  constructor() {
    super();
    Object.assign(this, {
      form: null,
      variantIndex: null,
      productOptionSelectors: null,
      productOptionCategories: null,
      variantInput: null,
      productJSON: null,
      variants: null,
      activeVariant: null,
      variantsData: null,
      validationInProgress: false,
      options: null,
      backgrounds: null,
      quantity: null,
      optionSelected: null,
      stickyOptionSelected: null,
      stickySelected: null,
      wcSticky: null,
      buttonContainer: null,
      variantChangeInProgress: false,
      bundleOptionColorMaps: {},
    });
  }

  get formActiveVartiant() {
    return this.activeVariant
  }

  connectedCallback() {
    this.productJSON = JSON.parse(this.dataset.productJson);
    document.addEventListener('DOMContentLoaded', this.trackViewItem);

    this.wcSticky = document.querySelector('wc-product-sticky-bar');
    this.wcStickyForm = this.wcSticky?.querySelector('form');
    this.stickyOptionSelectedList = this.wcSticky?.querySelectorAll('[data-selected-title]');
    this.stickySelectedList = this.wcSticky?.querySelectorAll('[data-sticky-selected-swatch]');
    this.stickyProductStickyOptionSelectors = this.wcStickyForm?.querySelectorAll(
      '[data-target="options"]'
    );
    this.stickyProductStickyOptionSelectors?.forEach((selector) => {
      selector.addEventListener('change', () => {
        this.updateVariantInput(selector);
      });
    });
    this.wcStickyForm?.addEventListener(
      'submit',
      this.handleAddToBag.bind(this)
    );

    this.productOptionSelectors = this.querySelectorAll(
      '[data-target="options"]'
    );
    this.faqAnchor = this.querySelector('[href="#faq"]');
    this.optionSelectedList = this.querySelectorAll('.wc-product-options__color-name');
    this.buttonContainer = this.querySelector('.wc-product-button-container');
    this.productOptionCategories = this.querySelectorAll('[data-category]');
    this.form = this.querySelector('.js-main-pdp-form');
    this.productOptionLabels = this.querySelectorAll('[data-option-category]');
    this.variantInput = this.form?.querySelector('[data-target="variant-id"]');
    this.variantIndex =
      this.form?.querySelector('[data-variant-index]:checked')?.dataset
        ?.variantIndex ?? 0;
    this.variants = this.productJSON.variants;
    this.options = this.productJSON.options;
    this.variantsData = this.productJSON.variants_display_data;
    this.backgrounds = this.productJSON.backgrounds;
    this.quantity = this.querySelector('[data-quantity-input]');
    this.bundleOptionColorMaps = this.buildBundleOptionColorMaps();

    if (this.querySelector('.wc-add-to-cart__buy-now')) {
      this.querySelector('.wc-add-to-cart__buy-now').addEventListener(
        'click',
        (e) => this.buyItNowHandle(e)
      );
    }

    document.addEventListener('variant:change', (e) => {
      this.buttonContainer?.classList.add('active');
      this.validate(e.detail.activeVariant);
      this.variantIndex = e.detail.activeVariantIndex;
    });

    this.form?.addEventListener('submit', this.handleAddToBag.bind(this));

    this.productOptionSelectors?.forEach((selector) => {
      selector.addEventListener('change', () => {
        this.updateVariantInput(selector);
      });
    });

    if (this.faqAnchor) {
      this.faqAnchor.addEventListener('click', (e) => {
        e.preventDefault();
        const faqSection = document.querySelector(
          this.faqAnchor.getAttribute('href')
        );
        if (faqSection) {
          const faqToggleMobile = document.querySelector('.js-wc-tab-faq-mobile');
          faqToggleMobile?.setAttribute('open', '');
          const faqToggleDesktop = document.querySelector('.js-wc-tab-faq-desktop');
          faqToggleDesktop?.dispatchEvent(new Event('click'));

          faqSection.scrollIntoView();
        }
      });
    }

    this.productOptionCategories?.forEach((selector) => {
      selector.addEventListener('click', () => {
        const currentActive = this.querySelector('.active[data-category]');
        currentActive.classList.remove('active');
        selector.classList.add('active');
        this.filterColor(selector.dataset.category);
      });
    });
    const formRendered = new CustomEvent('form:rendered');
    document.dispatchEvent(formRendered);
    console.log('formRendered')

    this.querySelectorAll('.js-wc-product__accordion')
      .forEach((accGroup) => {
        const trigger = accGroup.querySelector('.js-wc-product__button')
        const content = accGroup.querySelector('.js-wc-product__content')
        if (!trigger || !content) { return }
        trigger.addEventListener('click', () => {
          accGroup.classList.toggle('open')
        })
      })

    const ingredientsWrapper = this.querySelector('.js-wc-product__ingredients')
    if (ingredientsWrapper !== null) {
      const ingredientsToggles = ingredientsWrapper.querySelectorAll('.js-wc-product__ingredients-toggle')
      ingredientsToggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
          event.preventDefault()
          ingredientsWrapper?.classList.toggle('active');
          this.querySelector
        })
      })
    }

    this.validate();
    this.stockCheck();
    this.updateSwatchColors();
  }

  trackViewItem = () => {
    window.trackEvents.viewItem({ product: this.productJSON });
  }

  stockCheck = (activeVariant) => {
    if (!activeVariant)
      activeVariant = this.activeVariant
        ? this.activeVariant
        : this.getActiveVariant();

    if (!activeVariant.available || activeVariant.isOos) {
      this.classList.add('pdp-oos')

      this.buttonContainer?.classList.add('oos-state');
      if (this.wcSticky) {
        this.wcSticky
          .querySelector('#add-to-cart-button-sticky')
          .classList.add('oos-state');

        const stickyAtcText = activeVariant.has_sold_out_tag
          ? this.productJSON.language.soldOut
          : this.productJSON.language.notify

        this.wcSticky.querySelector(
          '#add-to-cart-button-sticky span'
        ).textContent = stickyAtcText
      }

    } else {
      this.classList.remove('pdp-oos')

      if (this.quantity) {
        const variantQuantity = this.variantsData?.find(
          (data) => data.id === activeVariant.id
        )?.inventory_quantity ?? 100

        this.quantity.max = variantQuantity
      }

      this.buttonContainer?.classList.remove('oos-state');
      this.querySelectorAll('[data-add-to-cart1] span')?.forEach((button) => {
        button.textContent = this.productJSON.language.addToCart;
      });
      if (this.wcSticky) {
        this.wcSticky
          .querySelector('#add-to-cart-button-sticky')
          .classList.remove('oos-state');
        this.wcSticky.querySelector(
          '#add-to-cart-button-sticky span'
        ).textContent = this.productJSON.language.addToCart;
      }
    }
  };

  validate = (activeVariant) => {
    if (this.validationInProgress) return;
    this.validationInProgress = true;
    activeVariant = activeVariant ? activeVariant : this.getActiveVariant();
    this.activeVariant = activeVariant;
    const hasVariant = activeVariant !== null;
    const price = document.querySelectorAll('[data-target="product-price"]');
    let formattedVariantPrice;
    let comparePrice;
    let priceHtml;

    this.variantInput.value = activeVariant?.id;

    if (hasVariant) {
      formattedVariantPrice = `$${(activeVariant.price / 100).toFixed(0)}`;
      comparePrice = `$${(activeVariant.compare_at_price / 100).toFixed(0)}`;

      let comparePriceHtml =
        activeVariant.compare_at_price > 0
          ? `<del data-target='compare-price'>${comparePrice}</del>`
          : '';

      priceHtml = `
            <p>
                <span id="pricePlacement">${formattedVariantPrice}</span>
                ${comparePriceHtml}
            </p>`;

      if (window.location.pathname.includes('/products/')) {
        this.updateURL(activeVariant.id);
      }
    }

    price.forEach((item) => {
      const el = item;
      el.innerHTML = priceHtml;
    });

    this.stockCheck(activeVariant);
    this.validationInProgress = false;
  };

  handleAddToBag = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const activeVariant = this.getActiveVariant();
    const canAddToCart = activeVariant.available && !activeVariant.isOos;

    if (!canAddToCart) {
      if (activeVariant.isComing) {
        this.buttonContainer?.classList.remove('active');
      } else if (activeVariant.isOos) {
        this.buttonContainer?.classList.remove('active');
      } else {
        this.buttonContainer?.classList.remove('active');
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });

      return;
    }

    const formD = new FormData(this.form);
    const sellingPlanId = formD.get('selling_plan');
    const originalProductQuantity = formD.get('quantity');

    let formData = {
      items: [
        {
          id: Number(activeVariant.id),
          quantity: originalProductQuantity,
        },
      ],
      sections: "wc-mini-cart"
    };

    if (sellingPlanId) {
      formData.items[0].selling_plan = sellingPlanId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        window.trackEvents.addToCart({
          lineItems: data.items.map((item) => ({
            ...item,
            quantity: originalProductQuantity,
          })),
        });
        window.dispatchEvent(new CustomEvent('MINI_CART_ACTION', {
          detail: {
            action: 'OPEN',
            cartResponseJson: data
          }
        }))
        return false
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  filterColor = (category) => {
    this.productOptionLabels.forEach((optionLabel) => {
      if (category === 'all') {
        optionLabel.classList.remove('hidden');
      } else {
        if (optionLabel.dataset.optionCategory === category) {
          optionLabel.classList.remove('hidden');
        } else {
          optionLabel.classList.add('hidden');
        }
      }
    });
    const firstCategorySelector = Array.from(this.productOptionLabels)
      .find((node) => node.dataset.optionCategory === category)
      .querySelector('input');
    this.updateVariantInput(firstCategorySelector);
  };

  updateURL = (variantId) => {
    if (!variantId || this.dataset.updateUrl === 'false') return;
    const url = new URL(location.href);
    url.searchParams.set('variant', variantId)
    window.history.replaceState({}, '', url);
  };

  getVariantForOptionValue = (activeVariant, optionName, optionValue) => {
    const targetOptions = {
      option1: activeVariant?.option1 ?? null,
      option2: activeVariant?.option2 ?? null,
      option3: activeVariant?.option3 ?? null,
    };
    targetOptions[optionName] = optionValue;

    return this.variants.find(
      (variant) =>
        variant.option1 === targetOptions.option1 &&
        variant.option2 === targetOptions.option2 &&
        variant.option3 === targetOptions.option3
    );
  };

  buildBundleOptionColorMaps = () => {
    const maps = {};
    if (!this.form || !window?.all_products || !window?.metafields?.products) return maps;

    const optionNames = (this.options || [])
      .map((_, index) => `option${index + 1}`);
    optionNames.forEach((optionName) => {
      const optionInputs = Array.from(
        this.form.querySelectorAll(`input[name="${optionName}"][data-target="options"]`)
      );
      if (!optionInputs.length) return;

      const optionValues = [...new Set(optionInputs.map((input) => input.value))];
      if (!optionValues.length) return;

      let matchedProductId = null;
      const products = window.all_products;
      Object.keys(products).some((productId) => {
        const product = products[productId];
        const variantTitles = new Set((product?.variants || []).map((variant) => variant.title));
        const isExactMatch = optionValues.every((value) => variantTitles.has(value));
        if (isExactMatch) {
          matchedProductId = productId;
          return true;
        }
        return false;
      });

      if (!matchedProductId) return;

      const matchedProduct = products[matchedProductId];
      const colorMap = {};
      (matchedProduct?.variants || []).forEach((variant) => {
        if (!optionValues.includes(variant.title)) return;
        const variantColor = window.metafields?.products?.[matchedProductId]?.color?.[variant.id]?.[0];
        if (variantColor) {
          colorMap[variant.title] = variantColor;
        }
      });

      if (Object.keys(colorMap).length) {
        maps[optionName] = colorMap;
      }
    });

    return maps;
  };

  updateSwatchInputs = (inputs, activeVariant) => {
    inputs?.forEach((input) => {
      const wrapper = input.closest('.product-options__option-wrapper');
      const swatch = wrapper?.querySelector('.product-options__option-label-color');
      if (!wrapper || !swatch) return;

      const optionName = input.getAttribute('name');
      const optionValue = input.value;
      const matchingVariant = this.getVariantForOptionValue(
        activeVariant,
        optionName,
        optionValue
      );
      const optionColorMap = this.bundleOptionColorMaps?.[optionName];
      const mappedColor = optionColorMap?.[optionValue];
      const color = mappedColor || this.backgrounds?.[matchingVariant?.id];

      const matchingVariantData = this.variantsData?.find(
        (data) => data.id === matchingVariant?.id
      );
      const isUnavailable = matchingVariant
        ? !matchingVariant.available || matchingVariantData?.is_soldout
        : false;

      if (color) {
        swatch.style.backgroundColor = color;
      }
      wrapper.classList.toggle('variant-unavailable', isUnavailable);
    });
  };

  updateStickySelectedSwatches = (activeVariant) => {
    if (!this.wcSticky) return;

    const isUnavailable = activeVariant?.available === false || activeVariant?.isOos;
    this.stickyOptionSelectedList?.forEach((el, index) => {
      const optionValue = activeVariant?.[`option${index + 1}`];
      el.textContent = optionValue || activeVariant?.title || '';
      el.classList.toggle('variant-unavailable', isUnavailable);
    });

    this.stickySelectedList?.forEach((el, index) => {
      const optionName = `option${index + 1}`;
      const selectedValue = activeVariant?.[optionName];
      const matchingVariant = this.getVariantForOptionValue(
        activeVariant,
        optionName,
        selectedValue
      );
      const mappedColor = this.bundleOptionColorMaps?.[optionName]?.[selectedValue];
      const color =
        mappedColor
        || this.backgrounds?.[matchingVariant?.id]
        || this.backgrounds?.[activeVariant?.id];

      if (color) {
        el.style.backgroundColor = color;
      }
      el.classList.toggle('variant-unavailable', isUnavailable);
    });
  };

  updateSwatchColors = (activeVariant = this.getActiveVariant()) => {
    const mainInputs = this.form?.querySelectorAll('[data-target="options"]');
    const stickyInputs = this.wcStickyForm?.querySelectorAll('[data-target="options"]');
    this.updateSwatchInputs(mainInputs, activeVariant);
    this.updateSwatchInputs(stickyInputs, activeVariant);
    this.updateStickySelectedSwatches(activeVariant);
  };

  updateVariantInput = (selector) => {
    if (this.variantChangeInProgress) return;
    this.variantChangeInProgress = true;
    // get the correct variant id, using getActiveVariant
    const selectorId = selector.getAttribute('id').replace('sticky-', '');
    document.querySelector(`#${selectorId}`).checked = true;
    const activeVariant = this.getActiveVariant();

    // set the value of the variant input to the variant id
    this.variantInput.value = activeVariant.id;

    if (this.wcSticky) {
      const stickyInput = document.querySelector(`#sticky-${selectorId}`);
      if (stickyInput) stickyInput.checked = true;
    }

    this.optionSelectedList?.forEach((el, index) => {
      const optionValue = activeVariant[`option${index + 1}`];
      el.textContent = optionValue || activeVariant.title;
    });
    this.updateSwatchColors(activeVariant);

    // const matchingInputs = Array.from(
    //   document.querySelectorAll('input')
    // ).filter((input) => input.value === selector.value);
    // matchingInputs.forEach((input) => input.click());
    // trigger custom event that can be used to update the price or other elements
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: { activeVariant, activeVariantIndex: activeVariant.index },
      })
    );
    this.variantChangeInProgress = false;
  };

  buyItNowHandle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const activeVariant = this.getActiveVariant();
    const canAddToCart = activeVariant.available && !activeVariant.isOos;

    if (!canAddToCart) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      return;
    }

    const formData = new FormData(this.form);

    const originalProductQuantity = formData.get('quantity');

    const payload = {
      items: [
        {
          id: Number(activeVariant.id),
          quantity: originalProductQuantity,
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const data = await response.json();
        window.trackEvents.addToCart({
          lineItems: data.items.map((item) => ({
            ...item,
            quantity: originalProductQuantity,
          })),
        });
        window.addInProgress = true;
        window.location.href = '/checkout';
        return false;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  serializeForm = () => {
    const formData = new FormData(this.form);
    const serializedArray = [];

    for (const [name, value] of formData.entries()) {
      serializedArray.push({ name, value });
    }

    return serializedArray;
  };

  getActiveVariant = () => {
    const formData = this.serializeForm(this);
    const formOptions = {
      option1: null,
      option2: null,
      option3: null,
    };
    let selectedVariant = null;

    const formHasOptions = formData.some(
      (item) => item.name.indexOf('option') !== -1
    );

    if (formHasOptions) {
      formData.forEach((item) => {
        if (item.name.indexOf('option') !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      this.variants.forEach((variant, index) => {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
          selectedVariant.index = index;
        }
      });
    } else {
      // eslint-disable-next-line prefer-destructuring
      selectedVariant = this.variants[0];
      selectedVariant.index = 0;
    }

    selectedVariant.isComing = this.variantsData.find(
      (data) => data.id === selectedVariant.id
    )?.is_coming;
    selectedVariant.isOos = this.variantsData.find(
      (data) => data.id === selectedVariant.id
    )?.is_soldout;

    return selectedVariant;
  };

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.trackViewItem);
    this.form?.removeEventListener('submit', this.handleAddToBag.bind(this));
    this.wcSticky.wcStickyForm.removeEventListener(
      'submit',
      this.handleAddToBag.bind(this)
    );
    // TODO: reinstate for price logic
    // this.form?.removeEventListener('change', this.validate);
    // this.form?.removeEventListener('load', this.validate);

    this.productOptionSelectors.forEach((selector) => {
      selector.removeEventListener('change', this.updateVariantInput());
    });
  }
}

if (!customElements.get('wc-product-form')) {
  customElements.define('wc-product-form', WCProductForm);
}
